import ModalPage from '~modules/crmIntegrations/elements/ModalPage'
import Button from '~shared/ui/Button'
import Flex from '~shared/ui/Flex'
import Text from '~shared/ui/Text'

interface OneTimeConversationsImportModalPageProps {
  actions: React.ReactNode
  integrationName: string
  onClose: () => void
}

function OneTimeConversationsImportModalPage({
  children,
  actions,
  integrationName,
  onClose,
}: React.PropsWithChildren<OneTimeConversationsImportModalPageProps>) {
  return (
    <ModalPage onClose={onClose}>
      <ModalPage.Header />

      <ModalPage.Body className="pb-4">
        <Text as="h1" variant="default" textType="heading-md" className="mb-2">
          One-Time Import
        </Text>

        <Text variant="secondary" textType="body-md" className="mb-2">
          Search for conversations in {integrationName} to be imported to Ignition
        </Text>

        {children}
      </ModalPage.Body>

      <ModalPage.Footer>
        <Flex align="center" justify="space-between" gap="2">
          <Button type="button" variant="secondary" className="px-4 py-1-5" onClick={onClose}>
            Close
          </Button>

          <Flex align="center" gap="2">
            {actions}
          </Flex>
        </Flex>
      </ModalPage.Footer>
    </ModalPage>
  )
}

export default OneTimeConversationsImportModalPage
